import React, { useEffect, useState } from 'react';
import SubscriptionService from 'src/services/Subscription.service';
import DateTimeService from 'src/utils/DateTimeService';
import BrandAutocomplete, { createOptionsFromArr } from '.';

function SubscriptionAutoComplete({
  onChange,
  value,
  name,
  label,
  pickKey,
  multiple = false,
  noLabel,
  filter = {},
  required = false
}) {
  const [options, setOptions] = useState([]);

  useEffect(() => {
    (async () => {
      const { data } = await SubscriptionService.get({
        ...filter,
        page: 0,
        perPage: 0,
        sortBy: '-createdAt',
        populate: ['planId']
      });


      const { data: subscriptions = [] } = data || {};
      const updatedSubscriptions = subscriptions.map((subscription) => {
        return {
          ...subscription,
          label: `${subscription.imei}-${
            subscription.planId.name
          }-${DateTimeService.getDateString(
            subscription.startDate
          )}-${DateTimeService.getDateString(subscription.endDate)}`
        };
      });
      setOptions(updatedSubscriptions);
    })();
  }, [JSON.stringify(filter)]);

  return (
    <BrandAutocomplete
      required={required}
      label={label}
      noLabel={noLabel}
      placeholder="Select subscriptions..."
      onChange={onChange}
      value={value}
      multiple={multiple}
      name={name ?? 'subscription'}
      options={createOptionsFromArr(options, 'label', pickKey || 'id')}
    />
  );
}

export default SubscriptionAutoComplete;
